export default {"src":"/_next/static/image/public/images/social_twitter_white.7527cde181fc2c3261e0b39e83098f67.svg","height":13,"width":16};